import { LitElement, html, css } from 'lit'
import { customElement } from 'lit/decorators.js'
import { TW } from '../../shared'

const TwLitElement = TW(LitElement)

/**
 * Sample Lit Element in assets/lit
 */
@customElement('button-phone')
export class ButtonPhone extends TwLitElement {

    static styles = css`
        :host {
            display: block;
        }
    `

    render() 
    {
        return html`<a href="tel:12345"><span class="bmw-icon bmw-icon-location-pin-rg before:text-lg"></span></a>`
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'button-phone': ButtonPhone
    }
}
